import { TableCell } from "@mui/material";
import Icon from "components/icon/icon";
import { BaseTableRow } from "./BaseTableRow";

const getQualityText = (quality: number, t: any) => {
  if (quality <= 1) return t("addressEncoding.tip.geoQuality.ADMIN1");
  if (quality <= 2) return t("addressEncoding.tip.geoQuality.Place");
  if (quality <= 3) return t("addressEncoding.tip.geoQuality.ZIP");
  return t("addressEncoding.tip.geoQuality.Exact");
};

export const MatchTableRow = ({
  currency,
  aggregationUnit,
  item,
  selectedId,
  onRowClick,
  handleMove,
  t
}: any) => {
  const handleMoveDefault = () => handleMove(item.id);

  return (
    <BaseTableRow
      currency={currency}
      aggregationUnit={aggregationUnit}
      item={item}
      selectedId={selectedId}
      onRowClick={onRowClick}
    >
      <TableCell
        sx={{
          fontSize: 13
        }}
      >
        {item.address}
      </TableCell>
      <TableCell
        sx={{
          fontSize: 13
        }}
      >
        {getQualityText(item.quality, t)}
      </TableCell>
      <TableCell>
        <div
          className="tooltip tooltip-left"
          data-tip={t("addressEncoding.tip.match")}
        >
          <Icon
            icon="error"
            style={{ color: "#666" }}
            onClick={handleMoveDefault}
          />
        </div>
      </TableCell>
    </BaseTableRow>
  );
};
